import { useTranslation } from "react-i18next";
import { RadioGroup, RadioGroupCardItem } from "@/components/ui/radio-group";
import { supportedLanguages } from "@/i18n";

import { cn } from "@/lib/utils";

export const LocaleSwitcher = ({ className }: { className?: string }) => {
  const { i18n } = useTranslation();

  const handleChange = (value: string) => {
    i18n.changeLanguage(value);
  };

  return (
    <RadioGroup
      className={cn("flex gap-0 rounded-sm border shadow-sm", className)}
      onValueChange={handleChange}
      value={i18n.language}
    >
      {Object.entries(supportedLanguages).map(([code, name]) => (
        <RadioGroupCardItem
          className="rounded-none border-none p-2.5 uppercase shadow-none first:rounded-l-sm last:rounded-r-sm"
          key={code}
          value={code}
        >
          {name}
        </RadioGroupCardItem>
      ))}
    </RadioGroup>
  );
};
